//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/ElectricalRouting.js";
import "../no/Object.js";
import "../no/Session.js";
let d=[[],[[["rootPart","activeWiringComp"],"SetActiveWiringComponent",{},2,0],[["rootPart","nWiringComponents"],"GetWiringComponents",{R_:{wiringComponents:"Assemblies.Component[]"}},1,0],[["harenssPart"],"DeleteWiringData",{},1,0],[["derivatives"],"ShowOnlyDerivatives",{},1,0],[["derivatives"],"DeleteDerivatives",{},1,0]],[["BuilderFactory","ElectricalRouting.BuilderFactory",0]]];
SPLM.ElectricalRouting.RoutingManager = class extends SPLM.Object{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.ElectricalRouting.RoutingManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;